// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V4IRGLiNUg9albjYhDhB{display:flex;flex-direction:column;gap:12px}.nGIOBCIjTwedtipghcba{padding:2px 0 !important}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/AgentKnowledgeBase/ui/PointKnowledgeBaseUsage/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEF,sBACE,wBAAA","sourcesContent":[".knowledgeBaseContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.knowledgeBaseLinkButton {\n  padding: 2px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"knowledgeBaseContainer": `V4IRGLiNUg9albjYhDhB`,
	"knowledgeBaseLinkButton": `nGIOBCIjTwedtipghcba`
};
export default ___CSS_LOADER_EXPORT___;
